// @flow
import { SUBMISSION_STATUS } from 'Client/cms/toolkit/constants';
import { SubmissionStatusLine } from 'Components/lines/submission-status-line/SubmissionStatusLine';

export const submissionStatusDescriptor = {
  name: SUBMISSION_STATUS,
  component: SubmissionStatusLine,
};
